/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/react/lib/Utilities';
import { action, observable } from 'mobx';
import { generateEntityColorFromString } from 'src/core/utils/color';
import { ModelType } from 'src/luis/types/ModelType';

export class CustomTextEntityStore {
    public readonly id: string;

    public readonly color: string;

    public readonly typeId: ModelType.Simple = ModelType.Simple;

    @observable public name: string;

    constructor(name: string) {
        this.name = name;
        this.id = getId();
        this.color = generateEntityColorFromString(name);
    }

    /**
     * Renames the entity
     * @param newName
     */
    @action
    public renameEntity(newName: string) {
        this.name = newName;
    }
}
